/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Dominik Boeck <d.boeck@techdivision.com>
 */

import { googleMapConfig } from '../../../../../Config/GoogleMapConfig';

/**
 * StudioMap Configuration
 */
export const studioMapConfig = {
  apiKey: googleMapConfig.apiKey,
  center: {
    lat: 51.015328,
    lng: 10.360078,
  },
  initialZoom: 4,
  zoom: 5,
  countryCode: 'de',
  defaultMapHeight: '500px',
};
